import { PageBuildLoader } from '@/components/PageBuildLoader';

export const IntegrationsIndex = () => {
  return <PageBuildLoader />;
};
